import { images } from ".";

const events = [
    {
        id: 1,
        image: images.event1,
        title: "AI Robotics Display",
        details: {
            date: "15 February, 2025",
            time: "9:00 AM",
            location: "Tech Hub",
            organizer: "AI Entrepreneurs Community",
            number: "+123-456-7890",
            email: "info@ainetworking.com",
            fee: "Free Admission"
        },
        paragraphs: [
            "Experience the latest advancements in AI-powered robotics at Tech Hub. Witness live demos showcasing innovative robotic solutions transforming industries.",
            "Engage with experts, explore interactive exhibits, and discover how AI is revolutionizing automation and robotics technology."
        ],
        gallery: [
            images.event1Gallery1,
            images.event1Gallery2
        ],
        agenda: [
            "Live Demonstrations of AI Robotics.",
            "Panel Discussions with Robotics Experts.",
            "Interactive Workshops on Robot Programming.",
            "Networking with Innovators and Investors.",
            "Exploring Future Trends in Robotics."
        ],
        speakerIds: [1, 6],
        venueMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2381.898560092926!2d-6.282664684098848!3d53.34980597997978!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48670e9f99f63a2d%3A0xf072be6ce11bc0c6!2sDublin%2C%20Ireland!5e0!3m2!1sen!2sus!4v1696598912345!5m2!1sen!2sus"
    },
    {
        id: 2,
        image: images.event2,
        title: "AI Hackathon for Startups",
        details: {
            date: "22 March, 2025",
            time: "10:00 AM",
            location: "Innovation Lab",
            organizer: "AI Entrepreneurs Community",
            number: "+123-456-7891",
            email: "hackathon@ainetworking.com",
            fee: "Registration Required"
        },
        paragraphs: [
            "Join our AI Hackathon designed for startups to develop cutting-edge AI solutions in a competitive and collaborative environment.",
            "Work alongside mentors, pitch your ideas to investors, and compete for prizes that can accelerate your AI business growth."
        ],
        gallery: [
            images.event2Gallery1,
            images.event2Gallery2
        ],
        agenda: [
            "Team Formation and Idea Brainstorming.",
            "Mentorship Sessions with AI Experts.",
            "Intensive Coding and Development.",
            "Pitching Final Solutions to Judges.",
            "Awards Ceremony and Networking."
        ],
        speakerIds: [3, 8],
        venueMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2381.898560092926!2d-6.282664684098848!3d53.34980597997978!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48670e9f99f63a2d%3A0xf072be6ce11bc0c6!2sDublin%2C%20Ireland!5e0!3m2!1sen!2sus!4v1696598912345!5m2!1sen!2sus"
    },
    {
        id: 3,
        image: images.event3,
        title: "AI Chess Insights",
        details: {
            date: "12 April, 2025",
            time: "3:00 PM",
            location: "Grand Hall, Tech Center",
            organizer: "AI & Gaming Innovators",
            number: "+123-456-7892",
            email: "chessinsights@aigaming.com",
            fee: "Free Admission"
        },
        paragraphs: [
            "Explore the cutting-edge intersection of artificial intelligence and chess strategies with leading AI developers and grandmasters.",
            "Discover how AI is revolutionizing chess analysis, training, and competitive play through interactive demos and expert talks."
        ],
        gallery: [
            images.event3Gallery1,
            images.event3Gallery2
        ],
        agenda: [
            "Keynote: AI Impact on Modern Chess.",
            "Live Demonstration of AI Chess Engines.",
            "Panel Discussion with Chess Grandmasters and AI Researchers.",
            "Interactive AI Chess Workshops.",
            "Networking and Closing Remarks."
        ],
        speakerIds: [5, 4],
        venueMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2381.898560092926!2d-6.282664684098848!3d53.34980597997978!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48670e9f99f63a2d%3A0xf072be6ce11bc0c6!2sDublin%2C%20Ireland!5e0!3m2!1sen!2sus!4v1696598912345!5m2!1sen!2sus"
    },
    {
        id: 4,
        image: images.event4,
        title: "AI-driven Drones",
        details: {
            date: "20 May, 2025",
            time: "10:00 AM",
            location: "Innovation Lab",
            organizer: "NextGen AI Robotics",
            number: "+123-456-7893",
            email: "drones@nextgenai.com",
            fee: "Free Admission"
        },
        paragraphs: [
            "Discover the latest advancements in AI-powered drone technology and its applications across industries such as delivery, surveillance, and agriculture.",
            "Engage with demos showcasing autonomous navigation, object recognition, and real-time data processing powered by AI."
        ],
        gallery: [
            images.event4Gallery1,
            images.event4Gallery2
        ],
        agenda: [
            "Introduction to AI in Drone Technology.",
            "Live Drone Flight Demonstrations.",
            "Panel Discussion on Ethical AI Drone Use.",
            "Workshops on Developing AI Algorithms for Drones.",
            "Networking and Q&A Sessions."
        ],
        speakerIds: [7, 2],
        venueMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2381.898560092926!2d-6.282664684098848!3d53.34980597997978!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48670e9f99f63a2d%3A0xf072be6ce11bc0c6!2sDublin%2C%20Ireland!5e0!3m2!1sen!2sus!4v1696598912345!5m2!1sen!2sus"
    },
    {
        id: 5,
        image: images.event5,
        title: "AI Entrepreneurs Conference",
        details: {
            date: "10 August, 2025",
            time: "8:30 AM",
            location: "Grand Convention Center",
            organizer: "Global AI Forum",
            number: "+123-456-7894",
            email: "conference@aiforum.com",
            fee: "$50 Admission"
        },
        paragraphs: [
            "Join leading AI entrepreneurs and innovators at the AI Entrepreneurs Conference to explore emerging trends, investment opportunities, and business strategies in AI.",
            "Attend keynote speeches, panel discussions, and workshops designed to inspire and empower the next generation of AI-driven startups."
        ],
        gallery: [
            images.event5Gallery1,
            images.event5Gallery2
        ],
        agenda: [
            "Keynote Address by AI Industry Leaders.",
            "Panel Discussions on AI Market Trends.",
            "Startup Pitch Competitions.",
            "Workshops on Fundraising and Scaling AI Businesses.",
            "Networking Sessions with Investors and Entrepreneurs."
        ],
        speakerIds: [1, 4],
        venueMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2381.898560092926!2d-6.282664684098848!3d53.34980597997978!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48670e9f99f63a2d%3A0xf072be6ce11bc0c6!2sDublin%2C%20Ireland!5e0!3m2!1sen!2sus!4v1696598912345!5m2!1sen!2sus"
    },
    {
        id: 6,
        image: images.event6,
        title: "AI Workshop Series",
        details: {
            date: "22 September, 2025",
            time: "10:00 AM",
            location: "Innovation Lab",
            organizer: "AI Learning Hub",
            number: "+123-456-7895",
            email: "workshops@ailearning.com",
            fee: "Free Admission"
        },
        paragraphs: [
            "Participate in our AI Workshop Series designed to provide hands-on learning experiences in AI technologies, tools, and applications.",
            "Work alongside experts in interactive sessions focused on practical AI skills, coding, and real-world problem solving."
        ],
        gallery: [
            images.event6Gallery1,
            images.event6Gallery2
        ],
        agenda: [
            "Introduction to AI Tools and Frameworks.",
            "Hands-on Coding Sessions.",
            "Data Science and Machine Learning Exercises.",
            "Q&A with AI Experts.",
            "Project Development and Presentation."
        ],
        speakerIds: [5, 6],
        venueMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2381.898560092926!2d-6.282664684098848!3d53.34980597997978!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48670e9f99f63a2d%3A0xf072be6ce11bc0c6!2sDublin%2C%20Ireland!5e0!3m2!1sen!2sus!4v1696598912345!5m2!1sen!2sus"
    }

];

export default events;